module.exports = __webpack_public_path__ + "img/double-chevron-left.4cdc4938.svg";